<template src="./auditlog.html"></template>
<script>

import AuditLogs from '@/pages/auditlog/auditlogdata/auditlogdata.vue';

export default {
  components: {
    AuditLogs,
  },
  data() {
    return {
    };
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions["Audit Logs"] ||
        !AccountPermissions["Audit Logs"]["enable"]) &&
      (!AccountPermissions["Audit Log"] ||
        !AccountPermissions["Audit Log"]["enable"])
    ) {
      this.$router.push("/");
    }
    document.title = pbx_SiteTitle + " - Audit Log";
  },

  methods: {
  },
};
</script>

<style type="text/css">
.auditloglist th{
    padding-bottom: 19px !important;
}
.search-data{
    padding: 12px 15px !important;
}
</style>
